import { Tenant } from "./../../interfaces/i-tenant";
import { IPlatform } from "./../../interfaces/i-platform";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiTenantService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public getDetail(tenantId: string): Observable<Tenant> {
        return this.http.get<Tenant>(
            this.baseUrl + "/tenant/" + tenantId + "/detail"
        );
    }
}
